import React, { useState, useEffect } from "react";
import {
  Box,
  Typography,
  Button,
  TextField,
  MenuItem,
  Autocomplete,
} from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { postJsonData } from "../network/ApiController";
import ApiEndpoints from "../network/ApiEndPoints";
import { apiErrorToast, okSuccessToast } from "../utils/ToastUtil";
import Loader from "../component/loading-screen/Loader";
import useCommonContext from "../store/CommonContext";

const BbpsParameters = ({ operator, parameters, onBack, operatorName }) => {
  const [formValues, setFormValues] = useState({});
  const [locations, setLocations] = useState([]);
  const [billDetails, setBillDetails] = useState(null);
  const [amount, setAmount] = useState("");
  const [loading, setLoading] = useState(false);
  const [mpin, setMpin] = useState(["", "", "", "", "", ""]);
  console.log("operatorName", operatorName);
  const { refreshUser } = useCommonContext();

  useEffect(() => {
    getLocations();
  }, []);

  const getLocations = () => {
    postJsonData(
      ApiEndpoints.BBPS2_GET_LOCATION,
      { operator_id: operator },
      null,
      (res) => {
        setLocations(res?.data?.data || []);
      },
      (err) => console.log(err),
    );
  };

  const handleChange = (e, name) => {
    setFormValues({
      ...formValues,
      [name]: e.target.value,
    });
  };

  const handleFetchBill = () => {
    const payload = {
      operator_id: operator,
      ...formValues,
      mobile: formValues.param2,
    };
    setLoading(true);

    postJsonData(
      ApiEndpoints.BBPS2_FETCHBILL,
      payload,
      null,
      (res) => {
        console.log("Fetch Bill Response:", res);

        const data = res?.data?.data;

        setBillDetails(data);

        if (data?.amount) {
          setAmount(data.amount); // 👈 fetched amount field me show hoga
        }
        setLoading(false);
      },
      (err) => {
        console.log(err);
        setLoading(false);

        apiErrorToast(err);
      },
    );
  };
  const handlePayBill = () => {
    const mpinValue = mpin.join("");

    if (mpinValue.length !== 6) {
      apiErrorToast("Enter valid 6 digit MPIN");
      return;
    }
    const payload = {
      operator_id: operator,
      ...formValues,
      mobile: formValues.param2,
      amount: amount,
      customer_id: billDetails?.customer_id,
      biller_name: operatorName,
      mpin: mpinValue, // 👈 add this
    };
    setLoading(true);

    postJsonData(
      ApiEndpoints.BBPS2_PAYBILL,
      payload,
      null,
      (res) => {
        console.log("Pay Bill Response:", res);
        okSuccessToast(res?.message);
        setLoading(false);
        refreshUser();
      },
      (err) => {
        console.log(err);
        setLoading(false);

        apiErrorToast(err?.message);
      },
    );
  };
  const handleMpinChange = (value, index) => {
    if (!/^[0-9]?$/.test(value)) return;

    const newMpin = [...mpin];
    newMpin[index] = value;
    setMpin(newMpin);

    if (value && index < 5) {
      document.getElementById(`mpin-${index + 1}`).focus();
    }
  };
  const handleKeyDown = (e, index) => {
    if (e.key === "Backspace") {
      if (mpin[index] === "" && index > 0) {
        document.getElementById(`mpin-${index - 1}`).focus();
      }

      const newMpin = [...mpin];
      newMpin[index] = "";
      setMpin(newMpin);
    }
  };
  return (
    <Loader loading={loading}>
      <Box sx={{ mt: 3 }}>
        <Box sx={{ mb: 2 }}>
          <Button
            startIcon={<ArrowBackIcon />}
            size="small"
            variant="contained"
            onClick={onBack}
          >
            Back
          </Button>
        </Box>
        <Box sx={{ display: "flex", gap: 3 }}>
          {/* LEFT SIDE - FETCH SECTION */}
          <Box sx={{ flex: 1, maxWidth: 400 }}>
            <Typography variant="h6" fontWeight="600" sx={{ mb: 2 }}>
              {operator?.name}
            </Typography>

            {parameters.map((param) => (
              <Box key={param.param_id} sx={{ mb: 2 }}>
                <TextField
                  fullWidth
                  size="small"
                  label={param.param_label}
                  value={formValues[param.param_name] || ""}
                  onChange={(e) => handleChange(e, param.param_name)}
                />
              </Box>
            ))}

            <TextField
              fullWidth
              size="small"
              label="Param 2"
              value={formValues.param2 || ""}
              sx={{ mb: 2 }}
              onChange={(e) => handleChange(e, "param2")}
            />

            {locations.length > 0 && (
              <Autocomplete
                size="small"
                options={locations}
                getOptionLabel={(option) => option.operator_location_name || ""}
                value={
                  locations.find(
                    (loc) => loc.operator_location_id === formValues.location,
                  ) || null
                }
                onChange={(e, newValue) =>
                  setFormValues({
                    ...formValues,
                    location: newValue?.operator_location_id || "",
                  })
                }
                renderInput={(params) => (
                  <TextField {...params} label="Location" sx={{ mb: 2 }} />
                )}
              />
            )}

            <Button variant="contained" size="small" onClick={handleFetchBill}>
              Fetch Bill
            </Button>
          </Box>

          {/* RIGHT SIDE - BILL DETAILS */}
          <Box
            sx={{
              flex: 1,
              maxWidth: 400,
              p: 2,
              border: "1px solid #ddd",
              borderRadius: 2,
              height: "fit-content",
            }}
          >
            <Typography variant="subtitle1" fontWeight="600" sx={{ mb: 2 }}>
              Bill Details({operatorName})
            </Typography>

            <TextField
              fullWidth
              size="small"
              label="Customer Name"
              value={billDetails?.customer_name || ""}
              sx={{ mb: 2 }}
              InputProps={{ readOnly: true }}
            />

            <TextField
              fullWidth
              size="small"
              label="Customer ID"
              value={billDetails?.customer_id || ""}
              sx={{ mb: 2 }}
              InputProps={{ readOnly: true }}
            />

            <TextField
              fullWidth
              size="small"
              label="Amount"
              value={amount}
              sx={{ mb: 2 }}
              onChange={(e) => setAmount(e.target.value)}
            />

            <TextField
              fullWidth
              size="small"
              label="Bill Date"
              value={billDetails?.bill_date || ""}
              sx={{ mb: 2 }}
              InputProps={{ readOnly: true }}
            />
            <Box sx={{ mb: 2 }}>
              <Typography variant="subtitle2" sx={{ mb: 1 }}>
                Enter MPIN
              </Typography>

              <Box sx={{ display: "flex", gap: 1 }}>
                {mpin.map((digit, index) => (
                  <TextField
                    key={index}
                    id={`mpin-${index}`}
                    type="password" // 👈 hidden input
                    value={digit}
                    onChange={(e) => handleMpinChange(e.target.value, index)}
                    onKeyDown={(e) => handleKeyDown(e, index)}
                    inputProps={{
                      maxLength: 1,
                      style: { textAlign: "center" },
                    }}
                    sx={{ width: 45 }}
                  />
                ))}
              </Box>
            </Box>

            <Button
              variant="contained"
              color="success"
              size="small"
              disabled={!billDetails}
              onClick={handlePayBill}
            >
              Pay Bill
            </Button>
          </Box>
        </Box>
      </Box>
    </Loader>
  );
};

export default BbpsParameters;
